module.exports = __webpack_public_path__ + "static/media/agricultural10.18703194.jpg";